export default __webpack_public_path__ + "static/media/kumomi.ffc1ceb2.mp3";